import BaseButton from '../BaseButton';
import { withDirtyFormProxyBaseButton } from './withDirtyFormProxyBaseButton';

const DirtyFormProxyBaseButton = withDirtyFormProxyBaseButton(BaseButton);

DirtyFormProxyBaseButton.displayName = 'DirtyFormProxyBaseButton';

export default DirtyFormProxyBaseButton;
